import PropTypes from 'prop-types'
import React, { Component } from 'react'

import SimpleModal from '../../common/SimpleModal'

class BuyBigModal extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.onEscape = this.onEscape.bind(this)
  }

  onEscape({ keyCode }) {
    if (keyCode === 27) {
      this.props.onClose()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onEscape)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscape)
  }

  render() {
    return (
      <SimpleModal
        hasPadding={this.props.hasPadding}
        onClose={this.props.onClose}
        show={this.props.display}
        title={this.props.h4}
        variant={this.props.variant}
      >
        {this.props.children}
      </SimpleModal>
    )
  }
}

BuyBigModal.defaultProps = {
  extraCssBody: {},
  extraStyle: {},
  hasPadding: true,
  variant: '',
}

BuyBigModal.propTypes = {
  children: PropTypes.element.isRequired,
  display: PropTypes.bool.isRequired,
  extraCssBody: PropTypes.object,
  extraStyle: PropTypes.object,
  h4: PropTypes.string.isRequired,
  hasPadding: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.string,
}

export default BuyBigModal
